// Codes promo : calcul de la remise côté panier.
//
// Un code « historique » (applicable_a absent) s'applique à tout le panier, comme avant. Un code
// réservé aux nouveaux produits (applicable_a = 'nouveaux-produits') ne remise que les articles dont
// productType est un faire-part animé ('minisite') ou la galerie ('galerie') ; les cartes à gratter
// du même panier gardent leur prix. Montants en euros (les prix du panier sont en centimes TTC).

export const NOUVEAUX_PRODUITS = ['minisite', 'galerie'];

export const articleEligible = (item, promo) => {
  if (!promo || !promo.applicable_a) return true;
  return promo.applicable_a === 'nouveaux-produits' && NOUVEAUX_PRODUITS.includes(item.productType);
};

export const panierEligible = (cart, promo) => (cart || []).some((item) => articleEligible(item, promo));

// Calcul en centimes entiers : 35 % de 19,90 € = 696,5 c → 6,97 € (arrondi au centime supérieur au demi).
export const calculerRemise = (cart, promo) => {
  if (!promo) return 0;
  const baseCents = (cart || [])
    .filter((item) => articleEligible(item, promo))
    .reduce((somme, item) => somme + Math.round(Number(item.price)) * Number(item.quantity || 1), 0);
  if (baseCents <= 0) return 0;
  const valeur = Number(promo.discount_value) || 0;
  let remiseCents = 0;
  if (promo.discount_type === 'percentage') remiseCents = Math.round((baseCents * valeur) / 100);
  else if (promo.discount_type === 'fixed') remiseCents = Math.min(baseCents, Math.round(valeur * 100));
  return remiseCents / 100;
};
